import React, { useEffect, useState } from "react";
import { motion } from 'framer-motion';
import { BsCurrencyRupee } from "react-icons/bs";
import { PiSealCheckDuotone } from "react-icons/pi";
import API from '../../Common/API'
import { setAlert } from '../../Store/Theme/actions'
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const PricingPlan = () => {
    const [planList, setPlanList] = useState([]);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [planDetails, setPlanDetails] = useState();
    const userDetails = useSelector((state) => state.auth.userDetails);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const [subscribedDetails, setSubscribedDetails] = useState();
    const history = useHistory();
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const lang = useSelector((state) => state.theme.language);

    useEffect(() => {
        setLoading(true);
        if (isLoggedIn) {
            axios.all([API.get('/plans/getPlansList'), API.get('/plans/getSubscribedPlan')])
                .then(axios.spread((planRes, subRes) => {
                    setPlanList(planRes.data.data);
                    setSubscribedDetails(subRes.data.data);
                    setLoading(false);
                }));
        } else {
            API.get('/plans/getPlansList').then((planRes) => {
                if (planRes.status === 200) {
                    setPlanList(planRes.data.data);
                    setLoading(false);
                }
            });
        }
    }, [count]);

    const makeOrder = (value) => {
        setPlanDetails(value);
        history.push('/payment');
    };

    const completeOrder = async (details) => {
        let apiValues = {
            planId: planDetails._id,
            userId: userDetails._id,
            planValidityDate: new Date(Date.now() + planDetails.planValidity * 24 * 60 * 60 * 1000),
            downloadCount: 0,
            transactionId: details.transactionId
        };

        try {
            const subRes = await API.post('/plans/subscribe', apiValues);
            if (subRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: 'Plan Subscribed Successfully', active: true, type: 'success' }));
                setCount(count + 1);
            }
        } catch (err) {
            dispatch(setAlert({ title: "Error", subtitle: 'Something went wrong', active: true, type: 'error' }));
        }
    };

    return (
        <div className="w-full min-h-screen px-4 py-10 flex flex-col items-center justify-start">
            <p className="text-2xl md:text-3xl font-bold text-primeColor text-center">{t('Plans and Pricing')}</p>
            <p className="text-sm md:text-md text-black text-center">{t('Choose the plan that suits you best')}</p>
            {
                loading ? (
                    <p className="mt-10 text-center">Loading, please wait...</p>
                ) : (
                    <motion.div className="w-full flex flex-wrap justify-center gap-6 mt-10">
                        {planList && planList.length > 0 && planList.map((plan, index) => (
                            <motion.div key={index} className="relative w-full sm:w-[300px] md:w-[320px] lg:w-[350px] h-auto bg-white flex flex-col shadow-lg px-5 py-6 gap-4 rounded-xl">
                                <p className="text-2xl font-bold text-primeColor">{plan.planName}</p>
                                <p className="flex items-center text-xl font-bold text-primeColor">
                                    <BsCurrencyRupee className="mr-1" /> {plan.planRate}
                                </p>
                                <p className="text-lg font-semibold">{t('Benefits')}</p>
                                <div className="flex flex-col gap-2">
                                    {plan.planBenefits && plan.planBenefits.length > 0 && plan.planBenefits.map((benefit, i) => (
                                        <p key={i} className="flex items-start text-sm">
                                            <PiSealCheckDuotone className="text-primeColor mt-1 mr-2" />
                                            {lang === 'en' ? benefit.benefits : benefit.tamilBenefits}
                                        </p>
                                    ))}
                                </div>
                                <motion.div
                                    className="mt-4 flex justify-center"
                                    onClick={() => !subscribedDetails?.planId && makeOrder(plan)}
                                >
                                    {isLoggedIn ? (
                                        <p
                                            className={`${subscribedDetails?.planId === plan._id
                                                ? 'bg-primeColor cursor-not-allowed'
                                                : 'bg-primeColor cursor-pointer hover:opacity-90'
                                                } font-bold text-white px-6 py-2 rounded-md text-sm`}
                                        >
                                            {subscribedDetails?.planId === plan._id ? t('Subscribed') : t('Subscribe')}
                                        </p>
                                    ) : (
                                        <p
                                            className="bg-primeColor cursor-pointer font-bold text-white px-6 py-2 rounded-md text-sm"
                                            onClick={() => history.push('/auth/login')}
                                        >
                                            {t('Subscribe')}
                                        </p>
                                    )}
                                </motion.div>
                            </motion.div>
                        ))}
                    </motion.div>
                )
            }
        </div>
    );
};

export default PricingPlan;